/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import { collection, getDocs, doc, deleteDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase"; 

import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";

import { 
  Grid, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Typography, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, 
  TextField, FormControl, InputLabel, Select, MenuItem 
} from "@mui/material";

export default function UsersManagement() {
  const [users, setUsers] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  
  const [currentUser, setCurrentUser] = useState({ 
    email: "", name: "", role: "employee"
  });

  const fetchUsers = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));
    setUsers(querySnapshot.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchUsers(); }, []);

  const handleSaveUser = async () => {
    await setDoc(doc(db, "users", currentUser.email), {
      name: currentUser.name,
      role: currentUser.role, 
    });
    setOpenAdd(false);
    setOpenEdit(false);
    setCurrentUser({ email: "", name: "", role: "employee" });
    fetchUsers();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ pt: 3, pb: 3, direction: "rtl" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ p: 3, borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#344767" }}>إدارة الموظفين والصلاحيات</Typography>
                <Button 
                  variant="contained" 
                  onClick={() => setOpenAdd(true)} 
                  sx={{ 
                    background: "#4CAF50", 
                    color: "#fff", 
                    fontWeight: "bold",
                    "&:hover": { background: "#388E3C" } 
                  }}
                >
                  + إضافة مستخدم جديد
                </Button>
              </Box>

              {/* 🟢 FULLY RESPONSIVE TABLE CONTAINER */}
              <TableContainer sx={{ overflowX: "auto", border: "1px solid #f0f2f5", borderRadius: "8px" }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead sx={{ display: "table-header-group" }}>
                    <TableRow>
                      {/* 🟢 أعمدة منفصلة للاسم والبريد */}
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#7b809a" }}>الاسم</TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold", color: "#7b809a" }}>البريد الإلكتروني</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold", color: "#7b809a" }}>الدور (Role)</TableCell> 
                      <TableCell align="center" sx={{ fontWeight: "bold", color: "#7b809a" }}>الإجراءات</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((user) => (
                      <TableRow key={user.id} hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        
                        {/* عمود الاسم */}
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          <Typography variant="button" fontWeight="medium" color="#344767">
                            {user.name}
                          </Typography>
                        </TableCell>

                        {/* عمود البريد الإلكتروني */}
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          <Typography variant="caption" color="textSecondary">
                            {user.id}
                          </Typography>
                        </TableCell>
                        
                        <TableCell align="center">
                          <Typography variant="caption" sx={{ 
                            fontWeight: "bold", 
                            color: user.role === "admin" ? "#1A73E8" : "#7b809a",
                            border: "1px solid",
                            padding: "4px 12px",
                            borderRadius: "10px",
                            backgroundColor: user.role === "admin" ? "rgba(26, 115, 232, 0.05)" : "transparent"
                          }}>
                            {user.role === "admin" ? "مدير نظام" : "موظف" }
                          </Typography>
                        </TableCell>
                        
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          <Button 
                            variant="contained" 
                            size="small" 
                            onClick={() => { setCurrentUser({...user, email: user.id}); setOpenEdit(true); }} 
                            sx={{ 
                              marginLeft: "10px", 
                              backgroundColor: "#1A73E8 !important", 
                              color: "#fff !important" 
                            }}
                          >
                            تعديل
                          </Button>
                          <Button 
                            variant="contained" 
                            size="small" 
                            onClick={() => { if(window.confirm("حذف المستخدم؟")) deleteDoc(doc(db, "users", user.id)).then(fetchUsers) }} 
                            sx={{ 
                              backgroundColor: "#F44336 !important", 
                              color: "#fff !important" 
                            }}
                          >
                            حذف
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* DIALOG FOR ADD/EDIT USER */}
      <Dialog open={openAdd || openEdit} onClose={() => { setOpenAdd(false); setOpenEdit(false); }} dir="rtl">
        <DialogTitle sx={{ textAlign: "right", fontWeight: "bold", color: "#344767" }}>
          {openAdd ? "إضافة مستخدم جديد" : "تعديل المستخدم"}
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2, minWidth: "400px" }}>
          
          <TextField label="الاسم" fullWidth value={currentUser.name} onChange={e => setCurrentUser({...currentUser, name: e.target.value})} />
          {openAdd && <TextField label="البريد الإلكتروني (Gmail)" fullWidth value={currentUser.email} onChange={e => setCurrentUser({...currentUser, email: e.target.value})} />}
          
          <FormControl fullWidth>
            <InputLabel id="role-select-label">نوع الحساب (Role)</InputLabel>
            <Select
              labelId="role-select-label"
              value={currentUser.role || "employee"}
              label="نوع الحساب (Role)"
              onChange={e => setCurrentUser({...currentUser, role: e.target.value})}
              sx={{ height: "45px" }}
            >
              <MenuItem value="employee">موظف (Employee)</MenuItem>
              <MenuItem value="admin">مدير نظام (Admin)</MenuItem>
            </Select>
          </FormControl>

        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => { setOpenAdd(false); setOpenEdit(false); }} sx={{ color: "#7b809a" }}>إلغاء</Button>
          <Button onClick={handleSaveUser} variant="contained" sx={{ background: "#4CAF50 !important", color: "#fff !important", fontWeight: "bold" }}>حفظ البيانات</Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}